var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgUnknownNc = function SvgUnknownNc(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 14 12"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M2.04 11.952h9.92c.946 0 1.54-.682 1.54-1.54a1.5 1.5 0 0 0-.202-.758L8.329.783a1.517 1.517 0 0 0-2.658 0L.708 9.66a1.55 1.55 0 0 0-.208.751c0 .859.593 1.54 1.54 1.54m4.963-4.218c-.328 0-.505-.19-.511-.524l-.089-3.434c-.006-.335.24-.575.594-.575.347 0 .606.246.6.58l-.089 3.43c-.006.34-.19.523-.505.523m0 2.115c-.372 0-.7-.303-.7-.675 0-.379.321-.682.7-.682.385 0 .707.297.707.682 0 .379-.328.675-.707.675"
  })));
};
export default SvgUnknownNc;